<template>
    <div class="infos">
        <div class="info"><b>Un prix du gaz compétitif et fixe</b> pour alléger vos factures énergétiques</div>
        <div class="info"><b>Une offre pour le retrait ou l’inertage de la cuve fioul pour vous faciliter la vie</b></div>
        <div class="info"><b>Des primes doublées avec le Coup de Pouce Chauffage Tertiaire</b> pour réduire votre budget</div>
        <div class="info"><b>Chauffage, cuisson et eau chaude</b>, avec le gaz, plus d’usages !</div>
    </div>
</template>

<script>
    export default {
        name: "LandingInfo"
    }
</script>

<style scoped lang="sass">
    @import ../../common/styles/settings
    @import ../../common/styles/mixins
    @import settings
    @import LandingInfo
</style>
